import React from "react";

import UserDropdown from "components/Dropdowns/UserDropdown.js";

export default function Navbar({ textNavbar }) {
  return (
    <>
      {/* Navbar */}
      <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
        <div className="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
          <a
            className="text-white text-sm uppercase hidden lg:inline-block font-semibold"
            href="#dashboard"
            onClick={(e) => e.preventDefault()}
          >
            {textNavbar}
          </a>
          
          <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
              <UserDropdown />
          </ul>
        </div>
      </nav>
      {/* End Navbar */}
    </>
  );
}
